import * as FIELD_NAME from 'constant/form-item-names'
import * as NUMBER from 'constant/number'
import { connect } from 'react-redux'
import { Form } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import OrganisationSelect from 'view/component/form-items/organisation-select'
import buildOrganisations from 'helper/build-organisations'

const ArticleOrgSelect = ({ categories, organisations }) => {
  const handleUpdate = (prevValues, currentValues) => prevValues.category_uuid !== currentValues.category_uuid
  return (
    <Form.Item
      noStyle
      shouldUpdate={handleUpdate}
    >
      {({ getFieldValue }) => {
        const categoryUuids = getFieldValue(FIELD_NAME.CATEGORY_UUID)
        return categoryUuids && categoryUuids?.length > NUMBER.ZERO
          ? (
            <OrganisationSelect
              organisations={buildOrganisations(organisations, categories, categoryUuids)}
            />
          )
          : null
      }}
    </Form.Item>
  )
}

ArticleOrgSelect.propTypes = {
  categories: PropTypes.array,
  organisations: PropTypes.array
}

const mapStateToProps = (state) => ({
  categories: state.category.managementCategories,
  organisations: state.organisation.organisations
})

export default connect(mapStateToProps)(ArticleOrgSelect)
